import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "38",
  height: "38",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FDE8E1",
      d: "M37.004 18.964c.582-.086.558-.932-.027-.986l-4.91-.445A13.78 13.78 0 0 1 19.68 5.812L18.964.933c-.085-.581-.932-.558-.985.028l-.446 4.91a13.78 13.78 0 0 1-11.72 12.386l-4.879.716c-.582.085-.558.932.027.985l4.91.446a13.78 13.78 0 0 1 12.387 11.72l.716 4.88c.085.58.932.558.985-.028l.446-4.91a13.78 13.78 0 0 1 11.72-12.387z"
    }, null, -1)
  ])))
}
export default { render: render }